// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1jpr6","author":"Table_author__91DHu","authorImage":"Table_authorImage__1kY6Y","unreadRow":"Table_unreadRow__2fSJy"};